import type { IAnalyticsEventFormField } from '@sravni/cosago-react-library/lib/types';
import { type FC, useCallback } from 'react';

import { useAppDispatch } from 'shared/lib';
import { sendEventFillFormField, SendEventWrapper } from 'shared/lib/sendGAEvents';
import { useUpdateStateBySelector } from 'shared/lib/useUpdateStateBySelector';

import {
  PassportFormValidationSchema,
  type TPassportFormFields,
  selectPassportInfoData,
} from 'src/client/entities/creditForm';

import { isResidenceSameAsRegistration } from '../../lib/isResidenceSameAsRegistration';
import { submitPassportForm } from '../../lib/submitPassportForm';
import { FormFieldsControls } from '../../PassportInfo.config';
import { PassportInfoTexts } from '../../PassportInfo.texts';
import { PassportInfoViewHoc } from '../FormBody/FormBody';

export const Form: FC<
  IFormPopup & {
    shouldRestoreAdditionalData?: boolean;
  }
> = ({
  isLoading,
  isDialog = false,
  onClose,
  setHeader,
  isFormForceOpened,
  onFormSubmit,
  shouldRestoreAdditionalData,
  stepIndex,
  formId,
  submitButtonText = 'Далее',
  isAnyFormStepOpenedInPopup,
  analyticsOverrides,
}) => {
  const dispatch = useAppDispatch();
  const [formData] = useUpdateStateBySelector(selectPassportInfoData);

  const handleData = async (actualData: TPassportFormFields, type: string) => {
    if (type === 'fullFilled') {
      actualData.residenceAddressIsRegistration = isResidenceSameAsRegistration(actualData);
      await dispatch(submitPassportForm(actualData, analyticsOverrides));
      onFormSubmit?.(actualData, isDialog);
    }
    if (isDialog) {
      onClose?.(true);
    }
  };

  const sendAnalyticsEvent = useCallback(
    ({ fieldName }: IAnalyticsEventFormField) => {
      sendEventFillFormField(
        stepIndex + 1,
        PassportInfoTexts[fieldName as keyof TPassportFormFields],
        true,
        analyticsOverrides,
      );
    },
    [stepIndex, analyticsOverrides],
  );

  return (
    <SendEventWrapper sendEvent={sendAnalyticsEvent}>
      <PassportInfoViewHoc
        isDialog={isDialog}
        onDataChanged={handleData}
        defaultData={formData}
        validationSchema={PassportFormValidationSchema()}
        isLoading={isLoading}
        additionalProps={{
          setHeader,
          isFormForceOpened,
          shouldRestoreAdditionalData: !!shouldRestoreAdditionalData,
          formId,
          isAnyFormStepOpenedInPopup,
          analyticsOverrides,
        }}
        formLabels={PassportInfoTexts}
        formFieldsControls={FormFieldsControls}
        submitButtonText={submitButtonText}
      />
    </SendEventWrapper>
  );
};
